module.exports = __webpack_public_path__ + "img/face.5fef12a.png";